import React, { useState, useEffect } from "react";
import { useUserDisplayName } from "../../../hooks/api/useUserDisplayName";

interface Props {
  userId: string | undefined | null;
  fallback?: string;
}

export const UserName = ({ userId, fallback = "-" }: Props) => {
  const { resolve } = useUserDisplayName();

  // Initialise directly from userId so the very first render shows something
  // sensible (the raw id) rather than the fallback "-".
  const [name, setName] = useState<string>(userId?.trim() || fallback);

  useEffect(() => {
    const trimmed = userId?.trim();

    if (!trimmed) {
      setName(fallback);
      return;
    }

    // Reset to the raw id immediately so switching products/items never shows
    // the previous user's resolved name while the new lookup is in flight.
    setName(trimmed);

    let cancelled = false;
    resolve(trimmed).then((n) => {
      if (!cancelled) setName(n);
    });

    return () => {
      cancelled = true;
    };
  }, [userId, fallback, resolve]);

  return <>{name}</>;
};
